module.exports = __webpack_public_path__ + "static/media/pic9.264fe3ac.jpg";